module.exports = __webpack_public_path__ + "media/images/flags/4x3/blr-3a1ae2185e9afd395e6b3faac65bfe81.svg";